import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity, BusinessType, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { RutterCompanyConnectionStatus } from './rutter-company-connection.status.enum';
import { RutterIntegrationConnectionType } from './rutter.integration.connection.type';
import { RutterPlatformData, RutterPlatformDataSchema } from './rutter-platform.data';
import { RutterConnectionMode } from './rutter-company-mode';
import { RutterConnectionPlatform } from './rutter-connection-platform.enum';

export const RutterCompanySchema = WithBaseEntitySchema(
    z.object({
        businessType: EnumSchema(BusinessType),
        accessToken: z.string(),
        integrationConnections: z
            .array(
                z.object({
                    id: z.string(),
                    platform: z.string(),
                    type: EnumSchema(RutterIntegrationConnectionType),
                }),
            )
            .optional(),
        totalCustomers: z.number().optional(),
        totalInvoices: z.number().optional(),
        totalItems: z.number().optional(),
        totalExpenses: z.number().optional(),
        status: EnumSchema(RutterCompanyConnectionStatus),
        upOnly: z.boolean().optional(),
        mode: EnumSchema(RutterConnectionMode).optional(),
        platformData: RutterPlatformDataSchema.optional(),
    }),
).strict();

export class RutterIntegrationConnection {
    id: string;
    platform: RutterConnectionPlatform;
    type: RutterIntegrationConnectionType;
}

export class RutterCompany extends FromSchema(RutterCompanySchema) implements BaseEntity {
    id: string;
    businessType: BusinessType;
    accessToken: string;
    integrationConnections?: RutterIntegrationConnection[];
    status: RutterCompanyConnectionStatus;
    platformData?: RutterPlatformData;
    totalCustomers?: number;
    totalInvoices?: number;
    totalItems?: number;
    totalExpenses?: number;
    upOnly?: boolean;
    mode?: RutterConnectionMode;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
